export const SIGNATURE_REQUEST_TRANSITION_STATES = {
  CANCELLED: 'cancelled',
  AWAITING_SIGNATURES: 'awaiting_signatures',
  SIGNED: 'signed',
  DECLINED: 'declined',
}

export type SignatureTransitionState =
  (typeof SIGNATURE_REQUEST_TRANSITION_STATES)[keyof typeof SIGNATURE_REQUEST_TRANSITION_STATES]

export type SignatureRequestTransition = {
  id: number
  createdAt: Date
  updatedAt: Date
  toState: SignatureTransitionState
  mostRecent: boolean
  adminUserId: number
  signatureRequestId: number
}

export type SignatureRequest = {
  id: number
  createdAt: Date
  updatedAt: Date
  externalId: string | null
  provider: string
  transitions: SignatureRequestTransition[]
}
